// import RegExpObj from '@/utils/regExp.js';

import synthesizeFormMixins from '../mixins/synthesize-form.js';
export default {
  mixins: [synthesizeFormMixins],
  components: {
  },
  props: ['projectInfo'],
  data() {
    return {
      bidGeneralSituation: 3, // 林地经营权
      massifs: [
        {
          massifName: '',
          area: null,
          price: null,
          toEast: '',
          toWest: '',
          toSouth: '',
          toNorth: '',
          woodClass: '',
          smallClass: '',
          attachment: '',
          originalContractor: '',
          certificateNo: '',
          serialNumber: '',
          forestSpecies: '',
          forestList: [
            {
              'treeSpecies': '',
              'treeNumber': ''
            },
            {
              'treeSpecies': '',
              'treeNumber': ''
            },
            {
              'treeSpecies': '',
              'treeNumber': ''
            }
          ]
        }
      ],
      rules: {
        massifName: [
          { required: true, message: '请输入地块名称', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请输入地块面积', trigger: 'blur' }
        ],
        serialNumber: [
          { required: true, message: '请输入林权证编号', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入地块转让总价格', trigger: 'blur' }
        ],
        toEast: [
          { required: true, message: '请输入东至', trigger: 'blur' }
        ],
        toWest: [
          { required: true, message: '请输入西至', trigger: 'blur' }
        ],
        toSouth: [
          { required: true, message: '请输入南至', trigger: 'blur' }
        ],
        toNorth: [
          { required: true, message: '请输入北至', trigger: 'blur' }
        ],
        woodClass: [
          { required: true, message: '请输入林班信息', trigger: 'blur' }
        ],
        smallClass: [
          { required: true, message: '请输入小班信息', trigger: 'blur' }
        ],
        forestSpecies: [
          { required: true, message: '请输入林种信息', trigger: 'blur' }
        ],
        attachment: [
          { required: true, message: '请输入地上附着物', trigger: 'blur' }
        ]
      }
    };
  },
  // watch: {
  //   projectInfo: {
  //     handler: function() {
  //       const assetsInfoList = this.projectInfo && JSON.parse(this.projectInfo.assetsInfo);
  //       const assetsInfo = assetsInfoList.find(item => item.bidGeneralSituation === this.bidGeneralSituation);
  //       if (assetsInfo) {
  //         this.totalForm.sumArea = assetsInfo.sumArea;
  //         this.totalForm.sumTreeNumber = assetsInfo.sumTreeNumber;
  //         this.massifs = assetsInfo.massifs;
  //       }
  //     },
  //     immediate: true
  //   }
  // },
  create() {
    this.totalForm = {
      ...this.totalForm,
      sumTreeNumber: null,
      massifTradeType: null
    };
  },
  methods: {
    // priceVali(rule, value, callback){
    //   if(value === '' || value === null){
    //     callback(new Error('请输入地块总转让价格'));
    //   } else if(value < 1 || value > 9999999.99){
    //     callback(new Error('请输入0-10000000以内的数字'));
    //   } else {
    //     callback();
    //   }
    // },
    // areaVali(rule, value, callback){
    //   if(value === '' || value === null){
    //     callback(new Error('请输入地块面积'));
    //   } else if(value < 1 || value > 99999.99){
    //     callback(new Error('请输入0-100000以内的数字'));
    //   } else {
    //     callback();
    //   }
    // },
    clear() {
      if( this.projectInfo.projectType === 2) return false;
      this.massifs = [
        {
          massifName: '',
          area: null,
          price: null,
          toEast: '',
          toWest: '',
          toSouth: '',
          toNorth: '',
          woodClass: '',
          smallClass: '',
          attachment: '',
          originalContractor: '',
          certificateNo: '',
          serialNumber: '',
          forestSpecies: '',
          forestList: [
            {
              'treeSpecies': '',
              'treeNumber': ''
            },
            {
              'treeSpecies': '',
              'treeNumber': ''
            },
            {
              'treeSpecies': '',
              'treeNumber': ''
            }
          ]
        }
      ],
      this.totalForm = {
        sumArea: null,
        sumTreeNumber: null
      };
      // 清空红色必填标示
      if(this.$refs['woodsForm']) {
        this.$refs['woodsForm'].resetFields();
      }
    },
    addLand () {
      this.massifs.push({
        massifName: '',
        area: null,
        serialNumber: '',
        price: null,
        toEast: '',
        toWest: '',
        toSouth: '',
        toNorth: '',
        woodClass: '',
        smallClass: '',
        attachment: '',
        originalContractor: '',
        certificateNo: '',
        forestSpecies: '',
        forestList: [
          {
            'treeSpecies': '',
            'treeNumber': ''
          },
          {
            'treeSpecies': '',
            'treeNumber': ''
          },
          {
            'treeSpecies': '',
            'treeNumber': ''
          }
        ]
      });
    },
    // 删除地块
    deleteLand (index) {
      this.massifs.splice(index, 1);
      let sumArea = 0;
      this.massifs.forEach(item => {
        sumArea += Number(item.area);
      });
      this.totalForm.sumArea = sumArea.toFixed(2);

      let sumTreeNumber = null;
      let treeNumber = null;
      this.massifs.forEach(item => {
        item.forestList.forEach(i => {
          treeNumber += Number(i.treeNumber);
        });
        sumTreeNumber += Number(treeNumber);
      });
      this.totalForm.sumTreeNumber = sumTreeNumber;
    },
    // 增加树种的时候
    changeTree() {
      let num = 0;
      if(this.massifs.length === 1) {
        this.massifs.forEach(item => {
          item.forestList.forEach(i => {
            num += Number(i.treeNumber);
          });
        });
      } else {
        this.massifs.forEach(item => {
          item.forestList.forEach(i => {
            num += Number(i.treeNumber);
          });
        });
      }
      this.totalForm.sumTreeNumber = num;
    }
    // 改变面积
    // changeArea (event, index) {
    //   if (!RegExpObj.num.test(this.massifs[index].area)) {
    //     return;
    //   }
    //   this.massifs[index].area = this.massifs[index].area && Number(this.massifs[index].area).toFixed(2);
    //   let num = 0;
    //   this.massifs.forEach(item => {
    //     num += Number(item.area);
    //   });
    //   this.totalForm.sumArea = num.toFixed(2);
    // },
    // test() {
    //   return new Promise((resolve, reject) => {
    //     let num = 0;
    //     this.massifs.forEach((form, index) => {
    //       form.price = 0;
    //       this.$refs[`woodsForm${index}`][0].validate((valid) => {
    //         if (valid) {
    //           num ++;
    //         } else {
    //           reject();
    //         }
    //       });
    //     });
    //     if (num === this.massifs.length) {
    //       resolve({
    //         massifs: JSON.parse(JSON.stringify(this.massifs)),
    //         ...this.totalForm,
    //         bidGeneralSituation: this.bidGeneralSituation
    //       });
    //     } else {
    //       reject();
    //     }
    //   });
    // }
  }
};
